import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ChevronRight } from '@saleshandy/icons';

import { Stage, stageOptions, stageOptionsNew } from '../stage';

type IProps = {
  stage: Stage;
  onStageChange: (state: Stage) => void;
  showUpdatedStageOptions?: boolean;
};

const ImportStageTabs: React.FC<IProps> = ({
  stage,
  showUpdatedStageOptions = false,
}) => {
  const options = useMemo(() => {
    const baseOptions = showUpdatedStageOptions
      ? stageOptionsNew
      : stageOptions;

    return baseOptions?.map((option) => ({
      ...option,
      ...(option?.value !== stage && { disabled: true }), // Disable all except current stage
    }));
  }, [showUpdatedStageOptions, stageOptionsNew, stageOptions, stage]);

  return (
    <div className="import-stage-tabs--container">
      {options.map((option, index) => (
        <>
          <div
            key={option.value}
            className={classNames([
              'import-stage-tabs--tab',
              { disabled: option.disabled, selected: option.value === stage },
            ])}
          >
            <p>{option.label}</p>
          </div>
          {index < options.length - 1 && (
            <div className="import-stage-tabs--icon">
              <ChevronRight />
            </div>
          )}
        </>
      ))}
    </div>
  );
};

export default ImportStageTabs;
